import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import List from "./List";
import Details from "./Details";

export default function Reports() {
  return (
    <Routes>
      <Route path="" element={<Navigate to="list" replace />} />
      <Route path="list" element={<List />} />
      <Route path="details/:id" element={<Details />} />
      <Route path="*" element={<div>Not found</div>} />
    </Routes>
  );
}